import React from 'react';
import { useDispatch } from 'react-redux';

import ConfirmationModal from '../ConfirmationModal';
import {
  unassignAccountManagerRequested,
  UNASSIGN_ACCOUNT_MANAGER_STORE_KEY,
} from '../../redux/organization-internal-owner/organization-internal-owner.actions';

interface UnassignAccountManagerConfirmModalProps {
  organizationId: string;
  displayName: string;
  onDismiss: () => void;
}

export const UnassignAccountManagerConfirmModal: React.FC<UnassignAccountManagerConfirmModalProps> = ({
  organizationId,
  displayName,
  onDismiss,
}) => {
  const dispatch = useDispatch();

  return (
    <ConfirmationModal
      title={`Unassign ${displayName}?`}
      text={`${displayName} will no longer be the account manager for this organisation.`}
      loadingActions={[UNASSIGN_ACCOUNT_MANAGER_STORE_KEY]}
      onDismiss={onDismiss}
      onSubmit={() => {
        dispatch(unassignAccountManagerRequested(organizationId));
        onDismiss();
      }}
    />
  );
};

export default UnassignAccountManagerConfirmModal;
